import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from '@core/store/store.service';
import { applicationTypeConfig } from '@module/submission-management/const/submission-management.const';
import { HelperService } from '@shared/services/helper.service';
import { TableTemplateControls } from '@shared/services/table-template-controls.service';
import { SimpleTableWrapperComponent } from '../simple-table-wrapper/simple-table-wrapper.component';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WCAGDummyLinkTargetDirective } from '@shared/directives/wcag-dummy-link-target.directive';

export const TABLE_DETAILS = {
  tableListApiUri: '/cfr-service/coiCheckList/pageSearch',
  tableHeaderType: 'FORM_HISTORY',
  tableFilter: null,
  hasViewTemple: true,
  hasActionTemple: false,
  title: '',
};

const tableDetailsMap = {
  coi: {
    tableListApiUri: `/cfr-service/coiCheckList/findHistoryById/`,
    title: 'coiHistory',
  },
  coiNotice: {
    tableListApiUri: `/cfr-service/coiNotice/findHistoryById/`,
    title: 'coiNoticeHistory',
  },
  application: {
    tableListApiUri: `/account-service/application/findHistoryById/`,
    title: 'applicationHistory',
  },
  VFB: {
    tableListApiUri: `/cfr-service/verification/findHistoryById/`,
    title: 'verificationHistory',
  },
  VLB: {
    tableListApiUri: `/cfr-service/verification/findHistoryById/`,
    title: 'validationHistory',
  },
};

@Component({
  selector: 'app-form-history',
  templateUrl: './form-history.component.html',
  styleUrls: ['./form-history.component.scss'],
  imports: [SimpleTableWrapperComponent, TranslateModule, FontAwesomeModule,
    WCAGDummyLinkTargetDirective
  ]
})
export class FormHistoryComponent implements OnInit {

  @Input() tableDetails: any;
  // tableDetails = TABLE_DETAILS;
  type: string;

  constructor(private tableTemplateControls: TableTemplateControls,
              private helperService: HelperService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private store: StoreService,
              ) { }

  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.type = params.type;
        const details = tableDetailsMap[params.type];
        if (!this.tableDetails) {
          this.tableDetails = {
            tableListApiUri: `${details.tableListApiUri}${params.id}`,
            title: details.title,
          };
        }
        this.tableDetails = { ...TABLE_DETAILS, ...this.tableDetails };

        this.tableTemplateControls._action.subscribe(metadata => {

          const inputData = metadata.data;
          const history = true;
          if (this.type === 'application') {

            const submissionType = `APPLICATION_${metadata.data.type}`;
            const data = { ...applicationTypeConfig[submissionType], inputData, history };
            this.router.navigate(
              this.helperService.getTranslatedPath(
                `/submission-management/wizard/${submissionType.replace(/_/g, '-').
                  toLowerCase()}`), { state: { data } });
          } else if (this.type === 'coi') {
            const data = {...inputData, history };
            this.router.navigate(
              this.helperService.getTranslatedPath(`/verification/manage-verification/coi-checklist/history/true`), { state: { data }});
          } else if (this.type === 'coiNotice') {
            const data = {...inputData, history };
            this.router.navigate(
              this.helperService.getTranslatedPath(`/verification/manage-notice-of-coi/form/history/true`), { state: { data }});
          } else {
            const data = {inputData, history };
            this.router.navigate(
              this.helperService.getTranslatedPath(`/submission-management/wizard/statement/${this.type}/history`), { state: { data }});
          }
        });
      }
    });

  }

  returnPreviousLocation(event) {
    event && event.preventDefault();
    this.store.back();
  }

}

